<template>
  <div>
    <Transition name="scroll-y-reverse-transition" mode="out-in">
      <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    </Transition>

    <v-row no-gutters>
      <auth></auth>
    </v-row>

    <!-- <v-app-bar app>
      <v-toolbar-title>RPD Testing</v-toolbar-title>
      <v-btn>Email Logs</v-btn>
      <v-btn>Log Out jvonmolt</v-btn>
    </v-app-bar> -->

    <v-main>
      <v-container class="cmpbk black--text" id="home-container">
        <v-row no-gutters>
          <v-col cols="12" md="12">
            <h2 class="alice">Manage Member Tests</h2>
            <xtabs></xtabs>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #home-container {
    width: 100vw;
    max-width: 100vw;
    height: auto;
  }

  .alice {
    color: aliceblue;
  }
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import xtabs from "./xtabs.vue";
import auth from "./auth.vue";
//import addedit_diag from "./addedit_diag.vue";
//  const addedit_diag = () => import('./addedit_diag.vue')

export default {
  name: "Home",
  components: {
    xtabs,
    auth,
  },
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      search: "",
      headers: [
        { text: "", value: "action1" },
        { text: "", value: "action2" },
        {
          text: "Last",
          align: "start",
          value: "lname",
        },
        { text: "First", value: "first" },
        { text: "Email", value: "email" },
        { text: "RPD#", value: "rpdNum" },
        { text: "Status", value: "status" },
        { text: "Certified", value: "certified" },
        { text: "Expires", value: "expires" },
        { text: "Assigned", value: "assigned" },
        { text: "CJIS Online", value: "cjisOnline", width: "115px" },
        { text: "Email Sent", value: "emailSent" },
        { text: "Division", value: "division", width: "95px" },
        { text: "Access", value: "access", width: "90px" },
        { text: "Modified", value: "modified" },
      ],
      // testTakers: [
      //   {
      //     lname: "abell",
      //     first: "Steven",
      //     email: "steven@email.com",
      //     rpdNum: "12299",
      //     status: "Assigned",
      //     certified: "05/12/2022",
      //     expires: "05/12/2023",
      //     assigned: "09/13/2022",
      //     cjisOnline: "01/01/1",
      //     emailSent: "08/26/2022",
      //     division: "SWORN",
      //     access: "INQIII",
      //     modified: "08/26/2022",
      //   },
      //   {
      //     lname: "Ferguson",
      //     first: "Maynard",
      //     email: "higher@email.com",
      //     rpdNum: "887744",
      //     status: "Assigned",
      //     certified: "04/01/2022",
      //     expires: "04/01/2023",
      //     assigned: "04/01/2022",
      //     cjisOnline: "01/01/1",
      //     emailSent: "08/26/2022",
      //     division: "SWORN",
      //     access: "ENTRY",
      //     modified: "08/26/2022",
      //   },
      //   {
      //     lname: "Terry",
      //     first: "Clark",
      //     email: "clark@email.com",
      //     rpdNum: "123456",
      //     status: "Assigned",
      //     certified: "11/12/2022",
      //     expires: "11/12/2023",
      //     assigned: "11/13/2022",
      //     cjisOnline: "01/01/1",
      //     emailSent: "11/26/2022",
      //     division: "SWORN",
      //     access: "INQIII",
      //     modified: "08/26/2022",
      //   },
      //   {
      //     lname: "Van Cleave",
      //     first: "Mark",
      //     email: "mark@email.com",
      //     rpdNum: "554477",
      //     status: "Assigned",
      //     certified: "02/26/2022",
      //     expires: "02/26/2022",
      //     assigned: "02/26/2022",
      //     cjisOnline: "02/26/2022",
      //     emailSent: "02/26/2022",
      //     division: "SWORN",
      //     access: "INQIII",
      //     modified: "08/26/2022",
      //   },
      //   {
      //     lname: "Chase",
      //     first: "Bill",
      //     email: "bill@email.com",
      //     rpdNum: "010101",
      //     status: "Assigned",
      //     certified: "05/12/2023",
      //     expires: "05/12/2023",
      //     assigned: "09/13/2022",
      //     cjisOnline: "01/01/1",
      //     emailSent: "08/26/2022",
      //     division: "SWORN",
      //     access: "INQIII",
      //     modified: "08/26/2022",
      //   },
      // ],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 10 || "Name must be less than 60 characters",
      ],
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      let self = this;
      this.init();
    },
  },
  methods: {
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },

    init(self) {
      this.show_loader(false);
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
